import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './bulk-approve-impact-analysis-dialog.controller';
import template from './bulk-approve-impact-analysis-dialog.html';


class dialogService {
  getOptions($event, { processes, assessmentId }) {
    return {
      controller,
      controllerAs: 'bulkApproveImpactAnalysisDialogVM',
      locals: {
        processes,
        assessmentId
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.bulkApproveImpactAnalysisDialog', [
  alerts,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('bulkApproveImpactAnalysisDialog', dialogService)
  .name;
